import type { PropType } from "vue";

export const buttonProps = {
  size: { type: String as PropType<"sm" | "md" | "lg">, default: "md" },
  outline: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
};

export type ButtonEmits = { click: [event: MouseEvent] };

export function createButtonClickHandler(
  props: Readonly<{ disabled: boolean; loading: boolean }>,
  emit: (event: "click", payload: MouseEvent) => void,
) {
  return (event: MouseEvent) => {
    if (!props.disabled && !props.loading) {
      emit("click", event);
    }
  };
}
